// Listen for Formie Stripe's custom beforeInit event and adjust options
(function formieStripeBeforeInitListener() {

  document.addEventListener('beforeInit', (event) => {
    try {
      const detail = event?.detail || {};
      const stripe = detail.stripe;
      if ( !stripe || !detail.elementOptions )
        return;

      // Use Formie's helper to read the donation frequency field value
      const donationFrequency = stripe.getFieldValue('{field:donationFrequency}');
      const isMonthly = String(donationFrequency || '').toLowerCase() === 'monthly';

      // Ensure to save payment method for monthly donations for future off-session use
      if ( detail.elementOptions.mode === 'payment' && isMonthly ) {
        detail.elementOptions.setup_future_usage = 'off_session';
      }
    } catch (e) {
      console.log(e);
      return;
    }
  }, true);

})();